<template>
	<svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clip-path="url(#clip0_69_140)">
			<path
				d="M39.65 0L5 20V60L39.65 80L74.3167 60V20L39.65 0ZM59.65 55.3C59.4533 57.7267 57.4367 59.62 54.9767 59.62C54.8267 59.62 54.68 59.6133 54.5333 59.6H54.5533C54.5267 59.6 54.4967 59.6 54.4667 59.6C52.11 59.6 49.9967 58.5567 48.5633 56.91L48.5567 56.9L28.5567 33.0967V55.2967V55.3433C28.5567 57.6867 26.6633 59.5867 24.32 59.5967H24.0533C21.6867 59.5767 19.7733 57.6633 19.7533 55.3V24.7C19.9167 22.2833 21.92 20.3833 24.3633 20.3833C24.5 20.3833 24.6367 20.39 24.77 20.4H24.7533H24.8833C27.2567 20.4 29.39 21.44 30.8467 23.0933L30.8533 23.1033L50.7533 46.9067V24.7033C50.7733 22.3367 52.6867 20.4233 55.05 20.4033H55.3033C57.67 20.4233 59.5833 22.3367 59.6033 24.7V55.3033L59.65 55.3Z"
				fill="#379F44" />
		</g>
		<defs>
			<clipPath id="clip0_69_140">
				<rect width="80" height="80" fill="white" />
			</clipPath>
		</defs>
	</svg>
</template>